import { render, staticRenderFns } from "./tabDeclined.vue?vue&type=template&id=7b2f08f2"
import script from "./tabDeclined.vue?vue&type=script&lang=js"
export * from "./tabDeclined.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports